import { useState, useEffect } from "react";

//Icons
import { useQuery } from "@apollo/client";
import { Autocomplete, TextField } from "@mui/material";

//Srcs
import { SELECT_USER, SELECT_MAIN_USER } from "../../Schema/User";
import {
  SELECT_ENROLLMENT_BY_STUDENT,
  SELECT_ACADEMIC_YEAR,
  SELECT_STUDENT,
  SELECT_GRADE_BY_ACADEMIC,
  SELECT_SCHOOL,
  SELECT_PROGRAMM,
} from "../../Schema/SchemaForSelect";
import { GET_UNIT_PAGINATION } from "../../Schema/Unit";
import { GET_CATEGORY_PAGINATION } from "../../Schema/Category";
import { SELECT_GROUP } from "../../Schema/Group";
import { GET_SECTION } from "../../Schema/Section";
import { GET_SIZE_PAGINATION } from "../../Schema/Size";
import { GET_MATERIAL_NAME_PAGINATION } from "../../Schema/MaterialName";
import { SELECT_MATERIAL } from "../../Schema/Material";
import { SELECT_SUPPLIER } from "../../Schema/Supplier";
import { SELECT_WAREHOUSE } from "../../Schema/Warehouse";
import { SELECT_UNIT_BYID_MATERIAL } from "../../Schema/Reqpurchase";
import { SELECT_OFFICE } from "../../Schema/Office";
import { GET_LEVEL_SECTION_PAGINATION } from "../../Schema/LevelSection";
import { GET_CLASS_BY_ACADEMIC_YEAR } from "../../Schema/ClassItem";
import { GET_STUDENT_BY_ACADEMIC_YEAR } from "../../Schema/SelectSchema";

// selete user form Hr employee
export function SelectMainUser({
  selectedVal,
  setSelectedVal,
  className,
  setFieldValue,
  errors,
  touched,
}) {
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);
  const [loading, setLoading] = useState(true);

  const { refetch } = useQuery(SELECT_MAIN_USER, {
    onCompleted: ({ selectMainUser }) => {
      setLoading(false);
      if (selectMainUser) {
        const Data = selectMainUser?.map((e, key) => {
          return {
            mainUserId: e?._id,
            title: key + 1 + ". " + e?.firstName + " " + e?.lastName,
            imageSrc: e?.imageSrc,
          };
        });
        setSelectOptions(Data);
      }
    },
    onError: (error) => {
      setLoading(true);
      // console.log(error?.message);
    },
  });
  const handleSelect = (val) => {
    setSelectedVal(val);
    setFieldValue("mainUserId", val?.mainUserId ?? "");
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch]);

  return (
    <Autocomplete
      disablePortal
      value={selectedVal}
      options={selectOptions}
      loading={loading}
      getOptionLabel={(option) =>
        option?.title === undefined ? "ជ្រើសរើស" : option?.title
      }
      isOptionEqualToValue={(option, value) => option?.value === value?.value}
      onChange={(event, val) => handleSelect(val)}
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          placeholder={"ជ្រើសរើស"}
          InputProps={{
            ...params.InputProps,
          }}
          error={Boolean(touched?.mainUserId && errors?.mainUserId)}
          helperText={touched?.mainUserId && errors?.mainUserId}
        />
      )}
    />
  );
}
export function SelectUser({
  selectedVal,
  setSelectedVal,
  className,
  setFieldValue,
  errors,
  touched,
}) {
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);
  const [loading, setLoading] = useState(true);

  const { refetch } = useQuery(SELECT_USER, {
    onCompleted: ({ selectUser }) => {
      setLoading(false);
      if (selectUser) {
        const data = selectUser?.map((e) => {
          return {
            _id: e?._id,
            title: e?.mainUserId?.firstName + " " + e?.mainUserId?.lastName,
            profileImage: e?.mainUserId?.imageSrc,
          };
        });
        setSelectOptions(data);
      }
    },
    onError: (error) => {
      setLoading(true);
    },
  });
  const handleSelect = (val) => {
    setSelectedVal(val);
    setFieldValue("userId", val?._id ?? "");
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch]);

  return (
    <Autocomplete
      disablePortal
      value={selectedVal}
      options={selectOptions}
      loading={loading}
      getOptionLabel={(option) =>
        option?.title === undefined ? "ជ្រើសរើស" : option?.title
      }
      isOptionEqualToValue={(option, value) => option?.value === value?.value}
      onChange={(event, val) => handleSelect(val)}
      renderInput={(params) => (
        <TextField
          {...params}
          // size="small"
          size="medium"
          placeholder={"ជ្រើសរើស"}
          InputProps={{
            ...params.InputProps,
            // startAdornment: (
            //   <InputAdornment position="start">
            //     <Avatar
            //       alt={selectedVal?.title}
            //       src={selectedVal?.profileImage ?? ""}
            //       sx={{ width: 56, height: 56 }}
            //     />
            //   </InputAdornment>
            // ),
          }}
          error={Boolean(touched?.userId && errors?.userId)}
          helperText={touched?.userId && errors?.userId}
        />
      )}
    />
  );
}

//======================= Select Unit =================
export function SelectUnit({
  selectedVal,
  setSelectedVal,
  className,
  error,
  helperText,
}) {
  //Change language
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);
  const [loading, setLoading] = useState(true);
  // console.log("selectedVal", selectedVal)

  const { refetch } = useQuery(GET_UNIT_PAGINATION, {
    variables: {
      page: 1,
      limit: 10,
      pagination: false,
      keyword: "",
      isUse: null,
    },
    onCompleted: ({ getUnitPagination }) => {
      setLoading(false);
      if (getUnitPagination) {
        // console.log("getUnitPagination", getUnitPagination)
        const Data = getUnitPagination?.data?.map((e) => {
          return {
            id: e?._id,
            title: e?.unitKhName,
          };
        });
        setSelectOptions(Data);
      }
    },
    onError: (error) => {
      setLoading(true);
      console.log(error?.message);
    },
  });
  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch]);

  return (
    <Autocomplete
      disablePortal
      value={selectedVal}
      options={selectOptions}
      loading={loading}
      getOptionLabel={(option) =>
        option?.title === undefined ? "ជ្រើសរើស" : option?.title
      }
      isOptionEqualToValue={(option, value) => option?.value === value?.value}
      onChange={(event, val) => handleSelect(val)}
      renderInput={(params) => (
        <TextField
          // className={className}
          {...params}
          size="small"
          placeholder={"ជ្រើសរើស"}
          InputProps={{
            ...params.InputProps,
          }}
          error={error}
          helperText={helperText}
          id="SelectUnit"
        />
      )}
    />
  );
}

//======================= Select Unit =================
export function SelectUnitList({ selectedVal, setSelectedVal, className }) {
  //Change language
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);
  const [loading, setLoading] = useState(true);
  // console.log("selectedVal", selectedVal)

  const { refetch } = useQuery(GET_UNIT_PAGINATION, {
    variables: {
      page: 1,
      limit: 10,
      pagination: false,
      keyword: "",
      isUse: null,
    },
    onCompleted: ({ getUnitPagination }) => {
      setLoading(false);
      if (getUnitPagination) {
        // console.log("getUnitPagination", getUnitPagination)
        const Data = getUnitPagination?.data?.map((e) => {
          return {
            id: e?._id,
            title: e?.unitKhName,
          };
        });
        setSelectOptions(Data);
      }
    },
    onError: (error) => {
      setLoading(true);
      console.log(error?.message);
    },
  });
  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch]);

  return (
    <Autocomplete
      multiple
      value={selectedVal}
      options={selectOptions}
      loading={loading}
      getOptionLabel={(option) =>
        option?.title === undefined ? "ជ្រើសរើស" : option?.title
      }
      isOptionEqualToValue={(option, value) => option?.value === value?.value}
      onChange={(event, val) => handleSelect(val)}
      renderInput={(params) => (
        <TextField
          className={className}
          {...params}
          size="small"
          placeholder={"ជ្រើសរើស"}
          InputProps={{
            ...params.InputProps,
          }}
          id="SelectUnit"
        />
      )}
    />
  );
}

//======================= Select category =================
export function SelectCategory({
  selectedVal,
  setSelectedVal,
  className,
  error,
  helperText,
  isUse,
}) {
  //Change language
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);
  const [loading, setLoading] = useState(true);
  // console.log("selectedVal", selectedVal)

  const { refetch } = useQuery(GET_CATEGORY_PAGINATION, {
    variables: {
      pagination: false,
      keyword: "",
      isUse: isUse ? true : null,
    },
    onCompleted: ({ getCategoryPagination }) => {
      setLoading(false);
      if (getCategoryPagination) {
        // console.log("getCategoryPagination", getCategoryPagination)
        const Data = getCategoryPagination?.data?.map((e) => {
          return {
            id: e?._id,
            title: e?.categoryKhName,
          };
        });
        setSelectOptions(Data);
      }
    },
    onError: (error) => {
      setLoading(true);
    },
  });
  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch]);

  return (
    <Autocomplete
      forcePopupIcon={true}
      value={selectedVal}
      options={selectOptions}
      loading={loading}
      getOptionLabel={(option) =>
        option?.title === undefined ? "ជ្រើសរើស" : option?.title
      }
      isOptionEqualToValue={(option, value) => option?.value === value?.value}
      onChange={(event, val) => handleSelect(val)}
      renderInput={(params) => (
        <TextField
          className={className}
          {...params}
          size="small"
          placeholder={"ជ្រើសរើស"}
          id="SelectCategory"
          error={error}
          helperText={helperText}
        />
      )}
    />
  );
}

//======================= Select Group =================
export function SelectGroup({
  selectedVal,
  setSelectedVal,
  className,
  error,
  helperText,
  isUse,
}) {
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);
  const [loading, setLoading] = useState(true);

  const { refetch } = useQuery(SELECT_GROUP, {
    variables: {
      keyword: "",
      isUse,
    },
    onCompleted: ({ selectGroup }) => {
      setLoading(false);
      if (selectGroup) {
        const Data = selectGroup?.map((e) => {
          return {
            id: e?._id,
            title: e?.groupKhName,
          };
        });
        setSelectOptions(Data);
      }
    },
    onError: (error) => {
      setLoading(true);
    },
  });
  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch]);

  return (
    <Autocomplete
      value={selectedVal}
      options={selectOptions}
      loading={loading}
      getOptionLabel={(option) =>
        option?.title === undefined ? "ជ្រើសរើស" : option?.title
      }
      isOptionEqualToValue={(option, value) => option?.value === value?.value}
      onChange={(event, val) => handleSelect(val)}
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          id="SelectGroup"
          placeholder={loading ? "Loading..." : "ជ្រើសរើស"}
          InputProps={{
            ...params.InputProps,
          }}
          error={error ? error : false}
          helperText={helperText ? helperText : ""}
          className={className}
        />
      )}
    />
  );
}

//======================= Select Section =================
export function SelectSection({
  selectedVal,
  setSelectedVal,
  className,
  disabled,
  error,
  helperText,
}) {
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);
  const [loading, setLoading] = useState(true);

  const { refetch } = useQuery(GET_SECTION, {
    variables: {
      keyword: "",
      isUse: true,
    },
    onCompleted: ({ getSection }) => {
      // console.log("getSection::", getSection)
      setLoading(false);
      if (getSection) {
        const Data = getSection?.map((e) => {
          return {
            id: e?._id,
            title: e?.sectionKhName,
          };
        });
        setSelectOptions(Data);
      }
    },
    onError: (error) => {
      setLoading(true);
    },
  });
  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch]);

  return (
    <Autocomplete
      disabled={disabled}
      value={selectedVal}
      options={selectOptions}
      loading={loading}
      getOptionLabel={(option) =>
        option?.title === undefined ? "ជ្រើសរើស" : option?.title
      }
      isOptionEqualToValue={(option, value) => option?.value === value?.value}
      onChange={(event, val) => handleSelect(val)}
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          id="SelectSection"
          placeholder={loading ? "Loading..." : "ជ្រើសរើស"}
          InputProps={{
            ...params.InputProps,
          }}
          error={error ? error : false}
          helperText={helperText ? helperText : ""}
          className={className}
        />
      )}
    />
  );
}

//========================== Select Size ===========================
export function SelectSize({ selectedVal, setSelectedVal, className }) {
  //Change language
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);
  const [loading, setLoading] = useState(true);
  // console.log("selectedVal", selectedVal)

  const { refetch } = useQuery(GET_SIZE_PAGINATION, {
    variables: {
      isUse: null,
      pagination: false,
      keyword: "",
      limit: 10,
      page: 1,
    },
    onCompleted: ({ getSizePagination }) => {
      setLoading(false);
      if (getSizePagination) {
        // console.log("getSizePagination", getSizePagination)
        const Data = getSizePagination?.data?.map((e) => {
          return {
            id: e?._id,
            title: e?.sizeKhName,
          };
        });
        setSelectOptions(Data);
      }
    },
    onError: (error) => {
      setLoading(true);
      console.log(error?.message);
    },
  });
  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch]);

  return (
    <Autocomplete
      value={selectedVal}
      options={selectOptions}
      loading={loading}
      getOptionLabel={(option) =>
        option?.title === undefined ? "ជ្រើសរើស" : option?.title
      }
      isOptionEqualToValue={(option, value) => option?.value === value?.value}
      onChange={(event, val) => handleSelect(val)}
      renderInput={(params) => (
        <TextField
          className={className}
          {...params}
          size="small"
          placeholder={"ជ្រើសរើស"}
          InputProps={{
            ...params.InputProps,
          }}
        />
      )}
    />
  );
}

export function SelectSizeList({ selectedVal, setSelectedVal, className }) {
  //Change language
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);
  const [loading, setLoading] = useState(true);
  // console.log("selectedVal", selectedVal)

  const { refetch } = useQuery(GET_SIZE_PAGINATION, {
    variables: {
      isUse: null,
      pagination: false,
      keyword: "",
      limit: 10,
      page: 1,
    },
    onCompleted: ({ getSizePagination }) => {
      setLoading(false);
      if (getSizePagination) {
        // console.log("getSizePagination", getSizePagination)
        const Data = getSizePagination?.data?.map((e) => {
          return {
            id: e?._id,
            title: e?.sizeKhName,
          };
        });
        setSelectOptions(Data);
      }
    },
    onError: (error) => {
      setLoading(true);
      console.log(error?.message);
    },
  });
  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch]);

  return (
    <Autocomplete
      multiple
      value={selectedVal}
      options={selectOptions}
      loading={loading}
      getOptionLabel={(option) =>
        option?.title === undefined ? "ជ្រើសរើស" : option?.title
      }
      isOptionEqualToValue={(option, value) => option?.value === value?.value}
      onChange={(event, val) => handleSelect(val)}
      renderInput={(params) => (
        <TextField
          className={className}
          {...params}
          size="small"
          placeholder={"ជ្រើសរើស"}
          InputProps={{
            ...params.InputProps,
          }}
        />
      )}
    />
  );
}

//======================= Select Material =================
export function SelectMaterial({
  selectedVal,
  setSelectedVal,
  className,
  isUse,
  groupId,
  sectionId,
}) {
  //Change language
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);
  const [loading, setLoading] = useState(true);
  // console.log("selectedVal", selectedVal)

  const { refetch } = useQuery(SELECT_MATERIAL, {
    variables: {
      isUse,
      groupId,
      sectionId,
    },
    onCompleted: ({ selectMaterial }) => {
      setLoading(false);
      if (selectMaterial) {
        console.log("selectMaterial", selectMaterial);
        const Data = selectMaterial?.map((e) => {
          return {
            id: e?._id,
            title: e?.materialKhName,
            unitSmall: e?.smallUnitId?.unitKhName,
          };
        });
        setSelectOptions(Data);
      }
    },
    onError: (error) => {
      setLoading(true);
      console.log(error?.message);
    },
  });
  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch]);

  return (
    <Autocomplete
      value={selectedVal}
      options={selectOptions}
      loading={loading}
      getOptionLabel={(option) =>
        option?.title === undefined ? "ជ្រើសរើស" : option?.title
      }
      isOptionEqualToValue={(option, value) => option?.value === value?.value}
      onChange={(event, val) => handleSelect(val)}
      renderInput={(params) => (
        <TextField
          className={className}
          {...params}
          size="small"
          placeholder={"ជ្រើសរើស"}
          InputProps={{
            ...params.InputProps,
          }}
        />
      )}
    />
  );
}

//======================= Select Supplier =================
export function SelectSupplier({
  selectedVal,
  setSelectedVal,
  className,
  disabled,
}) {
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);
  const [loading, setLoading] = useState(true);
  // console.log("selectedVal", selectedVal)

  const { refetch } = useQuery(SELECT_SUPPLIER, {
    onCompleted: ({ selectSupplier }) => {
      // console.log("selectSupplier::", selectSupplier)
      setLoading(false);
      if (selectSupplier?.length !== 0) {
        const Data = selectSupplier?.map((e) => {
          return {
            id: e?._id,
            title: e?.name,
          };
        });
        setSelectOptions(Data);
      }
    },
    onError: (error) => {
      setLoading(true);
      // console.log("error:", error)
    },
  });

  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch]);

  // console.log("selectOptions::", selectOptions)

  return (
    <Autocomplete
      disabled={disabled}
      value={selectedVal}
      options={selectOptions}
      loading={loading}
      className={className}
      getOptionLabel={(option) =>
        option?.title === undefined ? "ជ្រើសរើស" : option?.title
      }
      isOptionEqualToValue={(option, value) => option?.value === value?.value}
      onChange={(event, val) => handleSelect(val)}
      renderInput={(params) => (
        <TextField
          // className={className}
          {...params}
          size="small"
          placeholder={"ជ្រើសរើស"}
          InputProps={{
            ...params.InputProps,
          }}
        />
      )}
    />
  );
}
//======================= Select Office =================
export function SelectOffice({
  selectedVal,
  setSelectedVal,
  className,
  errors,
  touched,
  isUse,
  setFieldValue,
}) {
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);
  const [loading, setLoading] = useState(true);

  const { refetch } = useQuery(SELECT_OFFICE, {
    variables: {
      isUse,
    },
    onCompleted: ({ selectOffice }) => {
      setLoading(false);
      if (selectOffice?.length !== 0) {
        const Data = selectOffice?.map((e, key) => {
          return {
            id: e?._id,
            title: key + 1 + ". " + e?.officeKhName,
          };
        });
        setSelectOptions(Data);
      }
    },
    onError: (error) => {
      setLoading(true);
      // console.log("error:", error)
    },
  });

  const handleSelect = (val) => {
    setSelectedVal(val);
    setFieldValue("officeId", val?.id ?? "");
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch]);

  // console.log("selectOptions::", selectOptions)

  return (
    <Autocomplete
      value={selectedVal}
      options={selectOptions}
      loading={loading}
      className={className}
      getOptionLabel={(option) =>
        option?.title === undefined ? "ជ្រើសរើស" : option?.title
      }
      isOptionEqualToValue={(option, value) => option?.value === value?.value}
      onChange={(event, val) => handleSelect(val)}
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          placeholder={"ជ្រើសរើស"}
          InputProps={{
            ...params.InputProps,
          }}
          error={Boolean(touched?.officeId && errors?.officeId)}
          helperText={touched?.officeId && errors?.officeId}
        />
      )}
    />
  );
}

//======================= Select Warehouse =================
export function SelectWarehouse({
  selectedVal,
  setSelectedVal,
  className,
  disabled,
  defaultValue,
  error,
}) {
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);
  const [loading, setLoading] = useState(true);
  // console.log("selectedVal", selectedVal)

  const { refetch } = useQuery(SELECT_WAREHOUSE, {
    onCompleted: ({ selectWarehouse }) => {
      // console.log("selectWarehouse::", selectWarehouse);
      setLoading(false);
      if (selectWarehouse?.length !== 0) {
        const Data = selectWarehouse?.map((e) => {
          return {
            id: e?._id,
            title: e?.warehouseName,
          };
        });

        if (defaultValue) {
          setSelectedVal({
            id: Data[0]?.id,
            title: Data[0]?.title,
          });
        }
        setSelectOptions(Data);
      }
    },
    onError: (error) => {
      setLoading(true);
      // console.log("error:", error)
    },
  });

  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch]);

  // console.log("selectOptions::", selectOptions)

  return (
    <Autocomplete
      disabled={disabled}
      value={selectedVal}
      options={selectOptions}
      loading={loading}
      className={className}
      getOptionLabel={(option) =>
        option?.title === undefined ? "ជ្រើសរើស" : option?.title
      }
      isOptionEqualToValue={(option, value) => option?.value === value?.value}
      onChange={(event, val) => handleSelect(val)}
      renderInput={(params) => (
        <TextField
          // className={className}
          error={error || false}
          {...params}
          size="small"
          placeholder={"ជ្រើសរើស"}
          InputProps={{
            ...params.InputProps,
          }}
        />
      )}
    />
  );
}

//======================= Select class by student =================
export function SelectEnrollByStudent({
  selectedVal,
  setSelectedVal,
  className,
  studentId,
  academicId,
  disabled,
}) {
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);
  const [loading, setLoading] = useState(true);

  const { refetch } = useQuery(SELECT_ENROLLMENT_BY_STUDENT, {
    variables: {
      academicYearId: academicId,
      studentId: studentId,
    },
    onCompleted: ({ selectEnrollmentByStudent }) => {
      // console.log("selectEnrollmentByStudent::", selectEnrollmentByStudent);
      setLoading(false);
      if (selectEnrollmentByStudent?.length !== 0) {
        const Data = selectEnrollmentByStudent?.map((e) => {
          return {
            id: e?._id,
            title: e?.classId?.gradeId?.gradeName + "" + e?.classId?.className,
            gradeId: e?.classId?.gradeId?._id,
            gradeName: e?.classId?.gradeId?.gradeName,
          };
        });
        setSelectOptions([...Data]);
      } else {
        setSelectOptions([]);
      }
    },
    onError: (error) => {
      setLoading(true);
      // console.log("error:", error)
    },
  });

  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [academicId, studentId, checkRefetch]);

  return (
    <Autocomplete
      disabled={disabled}
      value={selectedVal}
      options={selectOptions}
      loading={loading}
      className={className}
      getOptionLabel={(option) =>
        option?.title === undefined ? "ជ្រើសរើស" : option?.title
      }
      isOptionEqualToValue={(option, value) => option?.value === value?.value}
      onChange={(event, val) => handleSelect(val)}
      renderInput={(params) => (
        <TextField
          // className={className}
          {...params}
          size="small"
          placeholder={"ជ្រើសរើស"}
          InputProps={{
            ...params.InputProps,
          }}
        />
      )}
    />
  );
}

//======================= Select class by student =================
export function SelectClassByAcademicYear({
  selectedVal,
  setSelectedVal,
  className,
  academicId,
  disabled,
}) {
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);
  const [loading, setLoading] = useState(true);

  const { refetch } = useQuery(GET_CLASS_BY_ACADEMIC_YEAR, {
    variables: {
      academicYearId: academicId,
    },
    onCompleted: ({ selectClass }) => {
      // console.log("selectClass::", selectClass);
      setLoading(false);
      if (selectClass?.length !== 0) {
        const Data = selectClass?.map((e) => {
          return {
            id: e?._id,
            title: e?.gradeId?.gradeName + " " + e?.className,
          };
        });
        setSelectOptions([...Data]);
      } else {
        setSelectOptions([]);
      }
    },
    onError: (error) => {
      setLoading(true);
      // console.log("error:", error)
    },
  });

  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [academicId, checkRefetch]);

  return (
    <Autocomplete
      disabled={disabled}
      value={selectedVal}
      options={selectOptions}
      loading={loading}
      className={className}
      getOptionLabel={(option) =>
        option?.title === undefined ? "ជ្រើសរើស" : option?.title
      }
      isOptionEqualToValue={(option, value) => option?.value === value?.value}
      onChange={(event, val) => handleSelect(val)}
      renderInput={(params) => (
        <TextField
          // className={className}
          {...params}
          size="small"
          placeholder={"ជ្រើសរើស"}
          InputProps={{
            ...params.InputProps,
          }}
        />
      )}
    />
  );
}

//======================= Select academic year =================
export function SelectAcademicYear({
  selectedVal,
  setSelectedVal,
  className,
  disabled,
}) {
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);
  const [loading, setLoading] = useState(true);

  const { refetch } = useQuery(SELECT_ACADEMIC_YEAR, {
    variables: {
      status: null,
    },
    onCompleted: ({ selectAcademicYears }) => {
      setLoading(false);
      if (selectAcademicYears?.length !== 0) {
        const Data = selectAcademicYears?.map((e) => {
          return {
            id: e?._id,
            title: e?.academicYear,
          };
        });
        setSelectOptions(Data);
      }
    },
    onError: (error) => {
      setLoading(true);
      // console.log("error:", error)
    },
  });

  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch]);

  return (
    <Autocomplete
      disabled={disabled}
      value={selectedVal}
      options={selectOptions}
      loading={loading}
      className={className}
      getOptionLabel={(option) =>
        option?.title === undefined ? "ជ្រើសរើស" : option?.title
      }
      isOptionEqualToValue={(option, value) => option?.value === value?.value}
      onChange={(event, val) => handleSelect(val)}
      renderInput={(params) => (
        <TextField
          // className={className}
          {...params}
          size="small"
          placeholder={"ជ្រើសរើស"}
          InputProps={{
            ...params.InputProps,
          }}
        />
      )}
    />
  );
}

//======================= Select academic year =================
export function SelectStudent({
  selectedVal,
  setSelectedVal,
  className,
  disabled,
}) {
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);
  const [loading, setLoading] = useState(true);

  const { refetch } = useQuery(SELECT_STUDENT, {
    onCompleted: ({ selectStudents }) => {
      setLoading(false);
      if (selectStudents?.length !== 0) {
        const Data = selectStudents?.map((e, key) => {
          return {
            id: e?._id,
            title:
              key +
              1 +
              ". " +
              e?.englishName +
              " - " +
              e?.lastName +
              " " +
              e?.firstName,
          };
        });
        setSelectOptions(Data);
      }
    },
    onError: (error) => {
      setLoading(true);
      // console.log("error:", error)
    },
  });

  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch]);

  return (
    <Autocomplete
      disabled={disabled}
      value={selectedVal}
      options={selectOptions}
      loading={loading}
      className={className}
      getOptionLabel={(option) =>
        option?.title === undefined ? "ជ្រើសរើស" : option?.title
      }
      isOptionEqualToValue={(option, value) => option?.value === value?.value}
      onChange={(event, val) => handleSelect(val)}
      renderInput={(params) => (
        <TextField
          // className={className}
          {...params}
          size="small"
          placeholder={"ជ្រើសរើស"}
          InputProps={{
            ...params.InputProps,
          }}
        />
      )}
    />
  );
}

//======================= Select student by academic year =================
export function SelectStudentByAcademicYear({
  selectedVal,
  setSelectedVal,
  className,
  disabled,
  academicYearId,
}) {
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);

  const { refetch } = useQuery(GET_STUDENT_BY_ACADEMIC_YEAR, {
    variables: {
      academicYearId: academicYearId ? academicYearId : null,
    },
    onCompleted: ({ getStudentByAcademicYearWeb }) => {
      let rows = [];
      if (getStudentByAcademicYearWeb?.length !== 0) {
        getStudentByAcademicYearWeb?.map((d, index) => {
          // console.log(
          //   "getStudentByAcademicYearWeb::",
          //   getStudentByAcademicYearWeb,
          // );
          const allRows = {
            id: d?._id,
            title:
              d?.familyEnglishName && d?.studentEnglishName
                ? `${index + 1}-${d?.familyEnglishName} ${
                    d?.studentEnglishName
                  }`
                : `${index + 1}-${d?.englishName}`,
            image: d?.profileImg,
          };
          rows.push(allRows);
          setSelectOptions(rows);
        });
      } else {
        setSelectOptions([]);
      }
    },
    onError: (error) => {
      console.log(error?.message);
    },
  });

  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [academicYearId]);

  return (
    <Autocomplete
      disabled={disabled}
      className={className}
      value={selectedVal}
      options={selectOptions}
      onChange={(event, val) => handleSelect(val)}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      getOptionLabel={(option) =>
        option.title === undefined ? "select value" : option.title
      }
      renderInput={(params) => (
        <TextField {...params} size="small" placeholder="select value" />
      )}
    />
  );
}

//======================= Select material unit =================
export function SelectMaterialUnitById({
  handleUpdateList,
  setSelectedVal,
  selectedVal,
  className,
  item,
}) {
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);
  const [loading, setLoading] = useState(true);
  // console.log("selectedVal", selectedVal)

  const { refetch } = useQuery(SELECT_UNIT_BYID_MATERIAL, {
    variables: {
      materialId: "",
    },
    onCompleted: ({ selectUnitByMaterialId }) => {
      setLoading(false);
      if (selectUnitByMaterialId) {
        const Data = selectUnitByMaterialId?.map((e) => {
          return {
            id: e?._id,
            title: e?.unitId?.unitKhName,
          };
        });
        setSelectOptions(Data);
      }
    },
    onError: (error) => {
      setLoading(true);
      console.log(error?.message);
    },
  });

  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch]);

  return (
    <Autocomplete
      value={selectedVal}
      options={selectOptions}
      loading={loading}
      className={className}
      getOptionLabel={(option) =>
        option?.title === undefined ? "ជ្រើសរើស" : option?.title
      }
      isOptionEqualToValue={(option, value) => option?.value === value?.value}
      onChange={(event, val) => {
        // setCheckShiftRefetch(true);
        handleUpdateList(item?.key, val, "bookId");
      }}
      renderInput={(params) => (
        <TextField
          // className={className}
          {...params}
          size="small"
          placeholder={"ជ្រើសរើស"}
          InputProps={{
            ...params.InputProps,
          }}
        />
      )}
    />
  );
}

//======================= Select Class =========================
export function SelectGrade({
  selectedVal,
  setSelectedVal,
  className,
  academicYearId,
  disabled,
}) {
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);
  const [loading, setLoading] = useState(true);

  const { refetch } = useQuery(SELECT_GRADE_BY_ACADEMIC, {
    variables: {
      academicYearId: academicYearId,
    },
    onCompleted: ({ selectGrade }) => {
      // console.log("selectGrade::", selectGrade);
      setLoading(false);
      if (selectGrade?.length !== 0) {
        const gradeData = selectGrade?.map((e) => {
          return {
            id: e?._id,
            title: e?.gradeName,
          };
        });
        setSelectOptions(gradeData);
      } else {
        setSelectOptions([]);
      }
    },
    onError: (error) => {
      setLoading(true);
      // console.log("error:", error)
    },
  });

  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch, academicYearId]);

  return (
    <Autocomplete
      disabled={disabled}
      value={selectedVal}
      options={selectOptions}
      loading={loading}
      className={className}
      getOptionLabel={(option) =>
        option?.title === undefined ? "ជ្រើសរើស" : option?.title
      }
      isOptionEqualToValue={(option, value) => option?.value === value?.value}
      onChange={(event, val) => handleSelect(val)}
      renderInput={(params) => (
        <TextField
          className={className}
          {...params}
          size="small"
          placeholder={"ជ្រើសរើស"}
          InputProps={{
            ...params.InputProps,
          }}
        />
      )}
    />
  );
}

//======================= Select Level Section =========================
export function SelectLevelSection({
  selectedVal,
  setSelectedVal,
  className,
  disabled,
}) {
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);
  const [loading, setLoading] = useState(true);

  const { refetch } = useQuery(GET_LEVEL_SECTION_PAGINATION, {
    variables: {
      page: 1,
      // limit: limit,
      pagination: false,
      keyword: "",
      isUse: null,
    },
    onCompleted: ({ getLevelSectionPagination }) => {
      // console.log("getLevelSectionPagination::", getLevelSectionPagination);
      setLoading(false);
      if (getLevelSectionPagination?.data?.length !== 0) {
        const gradeData = getLevelSectionPagination?.data?.map((e) => {
          return {
            id: e?._id,
            title: e?.levelSectionKhName,
          };
        });
        setSelectOptions(gradeData);
      } else {
        setSelectOptions([]);
      }
    },
    onError: (error) => {
      setLoading(true);
      // console.log("error:", error)
    },
  });

  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch]);

  return (
    <Autocomplete
      disabled={disabled}
      value={selectedVal}
      options={selectOptions}
      loading={loading}
      className={className}
      getOptionLabel={(option) =>
        option?.title === undefined ? "ជ្រើសរើស" : option?.title
      }
      isOptionEqualToValue={(option, value) => option?.value === value?.value}
      onChange={(event, val) => handleSelect(val)}
      renderInput={(params) => (
        <TextField
          className={className}
          {...params}
          size="small"
          placeholder={"ជ្រើសរើស"}
          InputProps={{
            ...params.InputProps,
          }}
        />
      )}
    />
  );
}
//======================= Select Programm =========================
export function SelectProgramm({
  selectedVal,
  setSelectedVal,
  className,
  // disabled,
}) {
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);
  const [loading, setLoading] = useState(true);
  const { refetch } = useQuery(SELECT_PROGRAMM, {
    onCompleted: ({ selectProgram }) => {
      // console.log("selectedProgram====", selectProgram);
      setLoading(false);
      if (selectProgram?.length !== 0) {
        const data = selectProgram?.map((e) => {
          return {
            id: e?._id,
            title: e?.programmName,
          };
        });
        // console.log("data", data);
        setSelectOptions(data);
      } else {
        setSelectOptions([]);
      }
    },
    onError: (error) => {
      setLoading(true);
      // console.log("error:", error)
    },
  });

  const handleSelect = (val) => {
    // console.log("val------", val);
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch]);

  // console.log("selectedVal:", selectedVal);
  // console.log("selectOptions:", selectOptions);
  return (
    <Autocomplete
      // disabled={disabled}
      multiple
      size="small"
      id="tags-standard"
      value={selectedVal}
      options={selectOptions}
      loading={loading}
      className={className}
      getOptionLabel={(option) =>
        option?.title === undefined ? "ជ្រើសរើស" : option?.title
      }
      // isOptionEqualToValue={(option, value) => option?.value === value?.value}
      onChange={(event, val) => handleSelect(val)}
      renderInput={(params) => (
        <TextField
          // className={className}
          {...params}
          size="small"
          placeholder={"ជ្រើសរើស"}
          // InputProps={{
          //   ...params.InputProps,
          // }}
        />
      )}
    />
  );
}
//======================= Select School =========================
export function SelectSchool({
  selectedVal,
  setSelectedVal,
  className,
  disabled,
}) {
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);
  const [loading, setLoading] = useState(true);

  const { refetch } = useQuery(SELECT_SCHOOL, {
    onCompleted: ({ selectSchool }) => {
      // console.log("selectSchool::", selectSchool);
      setLoading(false);
      if (selectSchool?.length !== 0) {
        const data = selectSchool?.map((e) => {
          return {
            id: e?._id,
            title: e?.schoolName,
          };
        });
        setSelectOptions(data);
      } else {
        setSelectOptions([]);
      }
    },
    onError: (error) => {
      setLoading(true);
      // console.log("error:", error)
    },
  });

  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch]);

  return (
    <Autocomplete
      disabled={disabled}
      value={selectedVal}
      options={selectOptions}
      loading={loading}
      className={className}
      getOptionLabel={(option) =>
        option?.title === undefined ? "ជ្រើសរើស" : option?.title
      }
      isOptionEqualToValue={(option, value) => option?.value === value?.value}
      onChange={(event, val) => handleSelect(val)}
      renderInput={(params) => (
        <TextField
          className={className}
          {...params}
          size="small"
          placeholder={"ជ្រើសរើស"}
          InputProps={{
            ...params.InputProps,
          }}
        />
      )}
    />
  );
}

//======================= Select  list level section =========================
export function SelectLevelSectionList({
  selectedVal,
  setSelectedVal,
  className,
}) {
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);
  const [loading, setLoading] = useState(true);
  const { refetch } = useQuery(GET_LEVEL_SECTION_PAGINATION, {
    variables: {
      page: 1,
      pagination: false,
      keyword: "",
      isUse: null,
    },
    onCompleted: ({ getLevelSectionPagination }) => {
      setLoading(false);
      if (getLevelSectionPagination?.data?.length !== 0) {
        const data = getLevelSectionPagination?.data?.map((e) => {
          return {
            id: e?._id,
            title: e?.levelSectionKhName,
          };
        });
        // console.log("data", data);
        setSelectOptions(data);
      } else {
        setSelectOptions([]);
      }
    },
    onError: (error) => {
      setLoading(true);
      // console.log("error:", error)
    },
  });

  const handleSelect = (val) => {
    // console.log("val------", val);
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch]);

  // console.log("selectedVal:", selectedVal);
  // console.log("selectOptions:", selectOptions);
  return (
    <Autocomplete
      // disabled={disabled}
      multiple
      size="small"
      id="tags-standard"
      value={selectedVal}
      options={selectOptions}
      loading={loading}
      className={className}
      getOptionLabel={(option) =>
        option?.title === undefined ? "ជ្រើសរើស" : option?.title
      }
      // isOptionEqualToValue={(option, value) => option?.value === value?.value}
      onChange={(event, val) => handleSelect(val)}
      renderInput={(params) => (
        <TextField
          // className={className}
          {...params}
          size="small"
          placeholder={"ជ្រើសរើស"}
          // InputProps={{
          //   ...params.InputProps,
          // }}
        />
      )}
    />
  );
}
//======================= Select  list secion =========================
export function SelectSectionList({ selectedVal, setSelectedVal, className }) {
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);
  const [loading, setLoading] = useState(true);
  const { refetch } = useQuery(GET_SECTION, {
    variables: {
      keyword: "",
      isUse: null,
    },
    onCompleted: ({ getSection }) => {
      setLoading(false);
      if (getSection?.length !== 0) {
        const data = getSection?.map((e) => {
          return {
            id: e?._id,
            title: e?.sectionKhName,
          };
        });
        // console.log("data", data);
        setSelectOptions(data);
      } else {
        setSelectOptions([]);
      }
    },
    onError: (error) => {
      setLoading(true);
      // console.log("error:", error)
    },
  });

  const handleSelect = (val) => {
    // console.log("val------", val);
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch]);

  // console.log("selectedVal:", selectedVal);
  // console.log("selectOptions:", selectOptions);
  return (
    <Autocomplete
      // disabled={disabled}
      multiple
      size="small"
      id="tags-standard"
      value={selectedVal}
      options={selectOptions}
      loading={loading}
      className={className}
      getOptionLabel={(option) =>
        option?.title === undefined ? "ជ្រើសរើស" : option?.title
      }
      // isOptionEqualToValue={(option, value) => option?.value === value?.value}
      onChange={(event, val) => handleSelect(val)}
      renderInput={(params) => (
        <TextField
          // className={className}
          {...params}
          size="small"
          placeholder={"ជ្រើសរើស"}
          // InputProps={{
          //   ...params.InputProps,
          // }}
        />
      )}
    />
  );
}
//======================= Select  list group =========================
export function SelectGroupList({ selectedVal, setSelectedVal, className }) {
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);
  const [loading, setLoading] = useState(true);
  const { refetch } = useQuery(SELECT_GROUP, {
    variables: {
      keyword: "",
      isUse: null,
    },
    onCompleted: ({ selectGroup }) => {
      setLoading(false);
      if (selectGroup?.length !== 0) {
        const data = selectGroup?.map((e) => {
          return {
            id: e?._id,
            title: e?.groupKhName,
          };
        });
        // console.log("data", data);
        setSelectOptions(data);
      } else {
        setSelectOptions([]);
      }
    },
    onError: (error) => {
      setLoading(true);
      // console.log("error:", error)
    },
  });

  const handleSelect = (val) => {
    // console.log("val------", val);
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch]);

  // console.log("selectedVal:", selectedVal);
  // console.log("selectOptions:", selectOptions);
  return (
    <Autocomplete
      // disabled={disabled}
      multiple
      size="small"
      id="tags-standard"
      value={selectedVal}
      options={selectOptions}
      loading={loading}
      className={className}
      getOptionLabel={(option) =>
        option?.title === undefined ? "ជ្រើសរើស" : option?.title
      }
      // isOptionEqualToValue={(option, value) => option?.value === value?.value}
      onChange={(event, val) => handleSelect(val)}
      renderInput={(params) => (
        <TextField
          // className={className}
          {...params}
          size="small"
          placeholder={"ជ្រើសរើស"}
          // InputProps={{
          //   ...params.InputProps,
          // }}
        />
      )}
    />
  );
}

//======================= Select list category =========================
export function SelectCategoryList({ selectedVal, setSelectedVal, className, isUse }) {
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);
  const [loading, setLoading] = useState(true);

   const { refetch } = useQuery(GET_CATEGORY_PAGINATION, {
    variables: {
      pagination: false,
      keyword: "",
      isUse: isUse ? true : null,
    },
    onCompleted: ({ getCategoryPagination }) => {
      setLoading(false);
      if (getCategoryPagination) {
        // console.log("getCategoryPagination", getCategoryPagination)
        const Data = getCategoryPagination?.data?.map((e) => {
          return {
            id: e?._id,
            title: e?.categoryKhName,
          };
        });
        setSelectOptions(Data);
      }else{
         setSelectOptions([]);
      }
    },
    onError: (error) => {
      setLoading(true);
    },
  });

  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch]);

  return (
    <Autocomplete
      // disabled={disabled}
      multiple
      size="small"
      id="tags-standard"
      value={selectedVal}
      options={selectOptions}
      loading={loading}
      className={className}
      getOptionLabel={(option) =>
        option?.title === undefined ? "ជ្រើសរើស" : option?.title
      }
      // isOptionEqualToValue={(option, value) => option?.value === value?.value}
      onChange={(event, val) => handleSelect(val)}
      renderInput={(params) => (
        <TextField
          // className={className}
          {...params}
          size="small"
          placeholder={"ជ្រើសរើស"}
          // InputProps={{
          //   ...params.InputProps,
          // }}
        />
      )}
    />
  );
}

//======================= Select  list material =========================
export function SelectMaterialList({ selectedVal, setSelectedVal, className }) {
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);
  const [loading, setLoading] = useState(true);

  const { refetch } = useQuery(SELECT_MATERIAL, {
    variables: {
      isUse: null,
      groupId: null,
      sectionId: null,
    },
    onCompleted: ({ selectMaterial }) => {
      setLoading(false);
      if (selectMaterial?.length !== 0) {
        const data = selectMaterial?.map((e) => {
          return {
            id: e?._id,
            title: e?.materialKhName,
          };
        });
        // console.log("data", data);
        setSelectOptions(data);
      } else {
        setSelectOptions([]);
      }
    },
    onError: (error) => {
      setLoading(true);
      // console.log("error:", error)
    },
  });

  const handleSelect = (val) => {
    // console.log("val------", val);
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch]);

  // console.log("selectedVal:", selectedVal);
  // console.log("selectOptions:", selectOptions);
  return (
    <Autocomplete
      // disabled={disabled}
      multiple
      size="small"
      id="tags-standard"
      value={selectedVal}
      options={selectOptions}
      loading={loading}
      className={className}
      getOptionLabel={(option) =>
        option?.title === undefined ? "ជ្រើសរើស" : option?.title
      }
      // isOptionEqualToValue={(option, value) => option?.value === value?.value}
      onChange={(event, val) => handleSelect(val)}
      renderInput={(params) => (
        <TextField
          // className={className}
          {...params}
          size="small"
          placeholder={"ជ្រើសរើស"}
          // InputProps={{
          //   ...params.InputProps,
          // }}
        />
      )}
    />
  );
}
